module.exports = __webpack_public_path__ + "img/HeadQ_Package.2455b6d6.png";